<template>
  <v-container fluid class="container-view">
    <v-card>
      <v-card-title
        class="text-h4 pa-6 text-white d-flex align-center"
        style="background-color: #ffb500"
      >
        <v-icon :icon="mdiChartLine" size="large" class="mr-3"></v-icon>
        {{ $t("projections.pageTitle") }}
        <v-spacer></v-spacer>
        <points-calculator-dialog />
      </v-card-title>

      <v-card-text class="pa-0">
        <!-- Étape 1: Liste des clients -->
        <v-window v-model="step" :touch="false">
          <v-window-item :value="1">
            <projection-customer-list
              @create-projection="handleCreateProjection"
            />
          </v-window-item>

          <!-- Étape 2: Formulaire de projection -->
          <v-window-item :value="2">
            <projection-form
              @go-back="goToCustomerList"
              @calculation-complete="handleCalculationComplete"
            />
          </v-window-item>

          <!-- Étape 3: Résultats -->
          <v-window-item :value="3">
            <v-row class="ma-4">
              <v-col>
                <v-btn-toggle
                  v-model="viewMode"
                  mandatory
                  color="#ffb500"
                  class="mb-4"
                >
                  <v-btn value="simple">
                    {{ $t("projections.simpleView") }}
                  </v-btn>
                  <v-btn value="comparison">
                    {{ $t("projections.comparisonView") }}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>

            <projection-results
              v-if="viewMode === 'simple'"
              @go-back="goToCustomerList"
              @modify-projection="goToForm"
            />

            <projection-comparison v-else @go-back="goToCustomerList" />
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { mdiChartLine } from "@mdi/js";
import ProjectionCustomerList from "../components/ProjectionCustomerList.vue";
import ProjectionForm from "../components/ProjectionForm.vue";
import ProjectionResults from "../components/ProjectionResults.vue";
import ProjectionComparison from "../components/ProjectionComparison.vue";
import PointsCalculatorDialog from "../components/PointsCalculatorDialog.vue";

export default {
  name: "ProjectionView",
  components: {
    ProjectionCustomerList,
    ProjectionForm,
    ProjectionResults,
    ProjectionComparison,
    PointsCalculatorDialog,
  },
  data() {
    return {
      step: 1,
      viewMode: "simple", // "simple" ou "comparison"
      mdiChartLine,
    };
  },
  methods: {
    ...mapActions("projections", ["resetProjection"]),
    handleCreateProjection() {
      this.step = 2;
    },
    handleCalculationComplete(selectedViewMode) {
      this.step = 3;
      // Définir le mode de vue selon le choix de l'utilisateur
      if (selectedViewMode) {
        this.viewMode = selectedViewMode;
      }
    },
    goToCustomerList() {
      this.step = 1;
      this.viewMode = "simple";
      this.resetProjection();
    },
    goToForm() {
      this.step = 2;
    },
  },
  beforeUnmount() {
    // Nettoie l'état lors de la sortie de la vue
    this.resetProjection();
  },
};
</script>

<style scoped>
.container-view {
  min-height: calc(100vh - 64px);
  padding: 24px;
}
</style>
